import { render, staticRenderFns } from "./NuevoTipoLiquidacion.vue?vue&type=template&id=55c436e6&"
import script from "./NuevoTipoLiquidacion.vue?vue&type=script&lang=js&"
export * from "./NuevoTipoLiquidacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports